<template>
  <Section :content="documents" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionDocuments',
  components: {
    Section,
  },
  data() {
    return {
      documents: { 
        eyebrow: 'TrinApp\u2122 Documents',
        eyebrowIcon: 'trinapp_cde.png',
        headline: 'Document storage, collaboration, and management',
        paragraphs: [
          'Store, access, and view documents in a TrinPod\u2122, a digital twin of the Business, Building, or Project they are related to.',
          'Eliminate having multiple copies of the same file. All stakeholders access the master document, not copies of the master document.', 
          'When the master document is updated, all stakeholders will view the updated version.'
        ],
        id: 'documents',
        image: 'TrinApp-Documents-web.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        /*html:
          '<div>' +
          ' <h3 class="mb-4">Document storage, collaboration, and management</h3>' +
          ' <p>Store, access, and view documents in a TrinPod\u2122, a digital twin of the Business, Building, or Project they are related to.</p>' + 
          ' <p>Eliminate having multiple copies of the same file. All stakeholders access the master document, not copies of the master document.</p>' +
          ' <p>When the master document is updated, all stakeholders will view the updated version.</p>' +
          '</div>',*/
        learnMoreLink: '/documents'
      }
      /*documents: { 
        header: 'TrinApp\u2122 Documents',
        headerIcon: 'trinapp_cde.png',
        id: 'documents',
        image: 'trinapp-documents.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        html:
          '<div>' +
          ' <h3>' +
          '  <p>Manage and collaborate on all documents.</p>' +
          '  <p>Read \x26 Crosslink PDF documents and store the Units-of-Thought to your TrinPod\u2122.</p>' +
          ' </h3>' +
          ' <ul>' +
          '  <li>Unlimited Free Users and collaborators.</li>' +
          '  <li>Detailed access control.</li>' +
          '  <li>Single Master Version.</li>' +
          '  <li>Organize documents in TrinPods\u2122 representing the Business, Building or Project they are related to</li>' +
          '  <li>Finding documents and information inside your documents becomes a breeze.</li>' +
          ' </ul>' +
          '</div>',
        learnMoreLink: '/documents'
      }*/
    }
  }
};
</script>
